<div class="modal-body">
  <div class="row">
    <div class="col-12">
      <div class="sk-folding-cube">
        <div class="sk-cube1 sk-cube"></div>
        <div class="sk-cube2 sk-cube"></div>
        <div class="sk-cube4 sk-cube"></div>
        <div class="sk-cube3 sk-cube"></div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <h2 class="text-center">{{ progressMessage }}</h2>
    </div>
  </div>
</div>
